import TabSlider from './TabSlider'
import reducer from './reducer'
import * as constants from './constants'

export default TabSlider
export { reducer, constants }
